import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Stack } from '@mantine/core';
import { DataTable, DataTableColumn } from 'mantine-datatable';
import useSiteProviders from '../hooks/useSiteProviders.ts';
import useRemitSettingStatus from '../hooks/useRemitSettingStatus.ts';
import { RemitSettingStatus } from '../models/remit-setting-status.ts';
import sortBy from 'lodash.sortby';
import SiteProviderStatusFilter from '../components/filter/SiteProviderStatusFilter.tsx';

export default function RemitSettingStatusesPage() {
  const nav = useNavigate();

  const { isLoading, data = [] } = useRemitSettingStatus();
  const [filter, setFilter] = useState({
    selectedProviders: [],
    selectedState: 'ALL',
  });

  const filteredData = useMemo(() => {
    return data
      .filter((item) => {
        return filter.selectedProviders.length === 0
          ? true
          : filter.selectedProviders.includes(item.siteProvider.id);
      })
      .filter((item) => {
        if (filter.selectedState === 'ALL') {
          return true;
        }
        if (
          filter.selectedState === 'ENABLED' &&
          item.remitSettingTypes.length > 0
        ) {
          return true;
        }

        return (
          filter.selectedState === 'DISABLED' &&
          item.remitSettingTypes.length === 0
        );
      });
  }, [data, filter]);

  const { data: siteProviders = [] } = useSiteProviders();

  const columns: DataTableColumn<RemitSettingStatus>[] = [
    {
      title: '廠商名稱',
      accessor: 'siteProviderName',
      render: (row) => row.siteProvider.name,
    },
    {
      title: '設定狀態',
      accessor: 'state',
      render: ({ remitSettingTypes }) => (
        <Box>{remitSettingTypes.length === 0 ? '尚未設定' : '已設定'}</Box>
      ),
    },
    {
      title: '操作',
      accessor: 'actions',
      render: (row) => (
        <Button
          size="xs"
          variant="outline"
          onClick={() =>
            nav(`/site-providers/${row.siteProvider.id}/remit-settings`)
          }
        >
          檢視
        </Button>
      ),
    },
  ];

  return (
    <Paper p="xl" radius="lg" shadow="xl" mb="xl">
      <Stack gap="xl">
        <SiteProviderStatusFilter
          providers={sortBy(siteProviders, 'name')}
          onFilter={setFilter}
        />
        <DataTable
          idAccessor={(row) => row.siteProvider.id}
          highlightOnHover
          minHeight={150}
          columns={columns}
          records={filteredData}
          verticalSpacing="xs"
          fetching={isLoading}
          noRecordsText="沒有廠商匯款設定"
        />
      </Stack>
    </Paper>
  );
}
